<template>
  <v-app class="bgImage">
    <v-app-bar app color="primary">
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light">{{appNameFirst}} </span>
        <span class="font-weight-medium">{{appNameSecond}}</span>
      </v-toolbar-title>
    </v-app-bar>

    <v-content class="secondary--text text--darken-2">
      <v-container fill-height>
        <v-row class="fill-height">
          <v-col cols="12">
            <v-row fill-height justify="center">
              <v-col xs="12" sm="8" md="6" lg="4">
                <v-card class="mt-10">
                  <v-card-title
                    class="primary text-center pa-4 secondary--text text--darken-3"
                  >
                    <v-row justify="center">
                      <span
                        class="text-uppercase text-center font-weight-light"
                      >
                        <span class="font-weight-medium">
                          Welcome
                        </span>
                      </span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="mb-2 mt-4 text-center">
                    <v-row>
                      <v-col>
                        <img src="/img/spider.png" alt="a spider" style="max-width:60%; height:auto;">
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <h2 class="text-uppercase secondary--text text--darken-3">
                          <span class="font-weight-light">{{appNameFirst}} </span>
                          <span class="font-weight-medium">{{appNameSecond}}</span>
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-row align="center" justify="center">
                      <m-form v-slot="{model}"
                      :query="apiEndpoints.login"
                      :rules="validationRules"
                      :modelSrc="loginData"
                      @success="onLoginSuccess"
                      lazy-validation>
                        <!--v-row align="center" justify="center">
                          <m-textinput
                            :model="model"
                            name="token"
                            label="Device Token"
                            required
                          ></m-textinput>
                        </v-row-->
                        <v-row align="center" justify="center">
                          <m-textinput
                            :model="model"
                            name="email"
                            label="Your Email Address"
                            type="email"
                            required
                          ></m-textinput>
                        </v-row>
                        <v-row>
                            <m-password
                                :model="model"
                                name="password"
                                label="Password"
                                required
                                ref="passwordInput"
                            ></m-password>
                        </v-row>
                        <v-row>
                            <m-submit label="Login" :model="model"> </m-submit>
                          <v-btn
                            text
                            :disabled="!valid"
                            color="primary"
                            class="mb-3"
                            @click="$router.push('/forgot_password')"
                          >
                            Forgot Password
                          </v-btn>
                        </v-row>
                      </m-form>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import apiQueries from '../mixins/api-endpoints';

export default {
  mixins: [apiQueries],
  data() {
    return {
      appNameFirst: process.env.MIX_APPNAME_FIRST,
      appNameSecond: process.env.MIX_APPNAME_SECOND,
      productName: process.env.MIX_PRODNAME,
      allowUnauthenticated:true,
      valid: true,
      showPassword: false,
      loginData:{
        password: '',
        email: '',
      },
      validationRules:{
        password: (model)=>[
            v => !!v || 'Password is required',
            v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        ],
        email: (model)=>[
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
      },
    };
  },
  methods: {
    onLoginSuccess(body) {
        this.storeToken(body.data);
        this.$router.push("/home");
    },
  },
};
</script>
